import AlphaHelpers from '../../abstracts/classes/alpha-helpers'
import debounce from 'lodash-es/debounce'

document.addEventListener('alpha.loaded', (e) => {
  const alphaModuleMgr = e.detail.emitter
  alphaModuleMgr.addModuleEventListener('slickCarousel', 'loaded', async () => {
    const productNavSliderEl = document.querySelector('.product-nav .alpha-image-gallery')
    const productSlideGalleryEl = document.querySelector('.product-slide')
    const productSlideSliderEl = document.querySelector('.product-slide .alpha-image-gallery')
    const variationsFormEl = document.querySelector('.variations_form[data-product_variations]')
    const variationIdInputEl = document.querySelector('[name="variation_id"]')
    const imageGalleryModule = await alphaModuleMgr.getOrAwaitModule('imageGallery')
    if (productNavSliderEl && productSlideSliderEl && variationsFormEl && variationIdInputEl && imageGalleryModule) {
      const variationsData = AlphaHelpers.getParsedJsonAttribute(variationsFormEl, 'data-product_variations')
      if (variationsData) {
        const slickSlider = jQuery(productSlideSliderEl)
        const productGallery = imageGalleryModule.getGalleryFromElement(productSlideGalleryEl)
        const defaultGalleryItems = productGallery.galleryItems
        const variationImageInitialized = {}

        const getVariationInfo = (variationId, variationsData) => {
          if (variationId.length) {
            variationId = parseInt(variationId, 10)
            const variationInfo = variationsData.find((v) => v.variation_id === variationId)
            if (variationInfo) {
              return variationInfo
            }
          }

          return null
        }

        const showDefaultImages = () => {
          // show navigation
          productNavSliderEl.classList.remove('opacity-0', 'pe-none')

          // only show default images (without variation data)
          slickSlider.slick('slickUnfilter')
          slickSlider.slick('slickFilter', (index, el) => el.querySelector('[data-variation-image-id]') === null)

          // reset gallery and force it to get default items list
          productGallery.refresh(defaultGalleryItems)
          productGallery.getItems()
        }

        const showVariationImage = (variationInfo) => {
          const imageId = parseInt(variationInfo.image_id, 10)
          if (imageId && variationInfo.alpha_image) {
            // hide navigation & clear slider filters
            productNavSliderEl.classList.add('opacity-0', 'pe-none')
            slickSlider.slick('slickUnfilter')

            // add new image to slider
            const isNewImage = !variationImageInitialized[imageId]
            if (isNewImage) {
              slickSlider.slick('slickAdd', variationInfo.alpha_image)
              variationImageInitialized[imageId] = true
            }

            // retrieve image info and pass it to gallery
            const variationPictureEl = productSlideSliderEl.querySelector(`[data-variation-image-id="${imageId}"]`)
            if (variationPictureEl) {
              const variationImageEl = variationPictureEl.querySelector('img')
              const imageInfo = {
                alt: variationImageEl.alt,
                src: variationPictureEl.getAttribute('data-src'),
                subHtml: '',
                thumb: variationImageEl.src
              }

              productGallery.refresh([imageInfo])
            }

            // only show current variation image
            slickSlider.slick('slickFilter', (index, el) => el.querySelector(`[data-variation-image-id="${imageId}"]`) !== null)

            // force gallery to get new items list
            productGallery.getItems()

            // bind click event to gallery if necessary
            if (isNewImage) {
              productGallery.openGalleryOnItemClick()
            }
          }
        }

        const debounceDelay = 25
        const onVariationChange = debounce(() => {
          const variationInfo = getVariationInfo(variationIdInputEl.value, variationsData)
          if (variationInfo) {
            showVariationImage(variationInfo)
          } else {
            showDefaultImages()
          }
        }, debounceDelay)

        jQuery(variationIdInputEl).on('change', onVariationChange)
      }
    }
  })
})
